import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { ProspectPropertiesStore } from "../stores/prospectPropertiesStore"

export const useProspectPropertiesStore = () => useContext<{
  prospectPropertiesStore: ProspectPropertiesStore;
}>(StoreContext)